/** Built (or already in the build-complete column) can leave the plant without a delivery route. */
export function unitCanShipFromPlant(
  unit: {
    staged_at: string | null;
    build_completed_at: string | null;
    current_phase_id: string | null;
  },
  phases: readonly { id: string; is_build_complete: boolean }[]
): boolean {
  if (unit.staged_at) return false;
  if (unit.build_completed_at) return true;
  const phase = phases.find((p) => p.id === unit.current_phase_id);
  return Boolean(phase?.is_build_complete);
}
